export default __webpack_public_path__ + "static/media/inviteSignup2.4c59f9f7.svg";